import Vue from "vue";
import OverlayTopicItemDetail from "./overlay-topic-item-detail.vue";

window.addEventListener("DOMContentLoaded", (e) => {
  const channelItems = document.querySelectorAll("[data-overlay-video]");
  channelItems.forEach((el) => {
    el.addEventListener("click", (e) => { clickHandler(e); });
  });

  const url = new URL(window.location.href);
  const item = url.searchParams.get("item_id");
  const parsedItem = Number.parseInt(item);

  if (Number.isInteger(parsedItem)) {
    const el = document.querySelector(`[data-topic-item-id="${parsedItem}"]`);
    el.click();
  }
});

function getMetaImageURL() {
  return document.head.querySelector("[property~='og:image'][content]").content;
}

function clickHandler(e) {
  e.preventDefault();

  const itemId = parseInt(e.currentTarget.getAttribute('data-topic-item-id'));
  const originalMetaImageURL = getMetaImageURL();
  const overlayNode = document.querySelector("[data-overlay-vue-container]");
  const shouldOpen = true;

  new Vue({
    el: overlayNode,

    components: { OverlayTopicItemDetail },

    data: {
      itemId: itemId,
      open: shouldOpen,
      originalMetaImageURL: originalMetaImageURL,
    },

    methods: {
      close() {
        this.open = false;
        window.MoMA.ScrollManager.enableScroll();
        const params = new URLSearchParams(location.search);
        params.delete("item_id");

        this.setMetaImage(this.originalMetaImageURL);
        window.history.replaceState({}, "", `${location.pathname}?${params}`);
      },

      setMetaImage(imageUrl) {
        document.querySelector("[property='og:image']").setAttribute("content", imageUrl);
      },
    },

    template: `
      <OverlayTopicItemDetail
        :itemId=itemId
        v-if="open"
        @close="close()"
        @setMetaImage="setMetaImage"
        >
      </OverlayTopicItemDetail>
      <div
        v-else
        data-overlay-vue-container>
      </div>
    `
  });
}
